import React, { memo } from 'react';
import { Card } from '../ui/Card';
import { StatusChip } from '../ui/StatusChip';
import { Button } from '../ui/Button';
import { BellIcon, CalendarIcon, CheckIcon } from 'lucide-react';
export function NextActionsWidget() {
  const actions = [{
    id: 1,
    type: 'reminder',
    customer: 'Rossi SRL',
    description: 'Invia promemoria di pagamento per fattura #INV-2023-105',
    dueDate: 'Oggi',
    status: 'overdue' as const,
    amount: '€2.450,00'
  }, {
    id: 2,
    type: 'installment',
    customer: 'Bianchi SpA',
    description: 'Rata #2 di 4 in scadenza per piano #PP-2023-021',
    dueDate: 'Domani',
    status: 'installments' as const,
    amount: '€1.250,00'
  }, {
    id: 3,
    type: 'approval',
    customer: 'Verdi & Figli',
    description: 'Piano di pagamento in attesa di approvazione',
    dueDate: 'Oggi',
    status: 'due-soon' as const,
    amount: '€3.750,00'
  }];
  const getActionIcon = (type: string) => {
    switch (type) {
      case 'reminder':
        return <BellIcon className="h-5 w-5 text-orange-300" data-id="element-602" />;
      case 'installment':
        return <CalendarIcon className="h-5 w-5 text-blue-300" data-id="element-603" />;
      case 'approval':
        return <CheckIcon className="h-5 w-5 text-green-300" data-id="element-604" />;
      default:
        return null;
    }
  };
  return <Card title="Prossime Azioni" data-id="element-605">
      <div className="divide-y divide-gray-200" data-id="element-606">
        {actions.map(action => <div key={action.id} className="py-4 first:pt-0 last:pb-0" data-id="element-607">
            <div className="flex items-start" data-id="element-608">
              <div className="flex-shrink-0 mt-1" data-id="element-609">
                {getActionIcon(action.type)}
              </div>
              <div className="ml-3 flex-1" data-id="element-610">
                <div className="flex items-center justify-between" data-id="element-611">
                  <p className="text-sm font-medium text-gray-900" data-id="element-612">
                    {action.customer}
                  </p>
                  <StatusChip status={action.status} data-id="element-613" />
                </div>
                <p className="text-sm text-gray-500" data-id="element-614">{action.description}</p>
                <div className="mt-2 flex items-center justify-between" data-id="element-615">
                  <div className="flex items-center" data-id="element-616">
                    <span className="text-sm text-gray-500" data-id="element-617">
                      Scadenza: {action.dueDate}
                    </span>
                    <span className="mx-2 text-gray-500" data-id="element-618">•</span>
                    <span className="text-sm font-medium" data-id="element-619">{action.amount}</span>
                  </div>
                  <Button variant="tertiary" data-id="element-620">Agisci</Button>
                </div>
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-4" data-id="element-621">
        <Button variant="secondary" fullWidth data-id="element-622">
          Visualizza tutte le azioni
        </Button>
      </div>
    </Card>;
}